export const roundedFieldSx = {
  '& .MuiOutlinedInput-root': {
    borderRadius: '999px',
    backgroundColor: 'white',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
  },
};

export const roundedOtpFieldSx = {
  width: 52,
  '& .MuiOutlinedInput-root': {
    borderRadius: '16px',
    backgroundColor: 'white',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
  },
};
